module.exports = __webpack_public_path__ + "assets/img/main_img_half_top.b401b1cc.svg";